<template>
    <div class="card-body p-30" v-if="service_list.length>0">
        <div class="row">
            <div class="col-lg-4 col-xl-3">
                <!-- Nav tabs -->
                <div aria-orientation="vertical" class="nav flex-column nav-pills"
                     id="v-pills-tab"
                     role="tablist">
                    <template v-for="(service, index) in service_list">
                        <a :class="{'active service-active': activeTab === index+1}"
                           :href="'#finance_item'+index+1"
                           :id="'#finance_item'+index+1" @click="tab(index+1)"
                           aria-controls="v-pills-home"
                           aria-selected="true" class="nav-link" data-toggle="pill"
                           role="tab">{{service.name}}</a>
                    </template>
                </div>
            </div>
            <div class="col-lg-8 col-xl-9">
                <div class="tab-content" id="v-pills-tabContent">
                    <template v-for="(service, index) in service_list">
                        <div :class="{'show active': activeTab === index+1}"
                             :id="'#finance_item'+index+1"
                             aria-labelledby="v-pills-home-tab" class="tab-pane fade"
                             role="tabpanel">
                            <div class="card-body">
                                <div :id="'finance_accordionid'+index">
                                    <div :key="'finance_item'+index+index2"
                                         class="card mb-0  card-border"
                                         v-for="(claim, index2) in service.items">
                                        <div :id="'finance_heading'+index+index2"
                                             class="card-header bg-grey card-header-border p-1">
                                            <div :data-target="'#finance_collapse'+index+index2"
                                                 data-toggle="collapse"
                                                 style="cursor: pointer">
                                                <a :data-target="'#finance_collapse'+index+index2"
                                                   aria-controls="collapseOne"
                                                   aria-expanded="true"
                                                   class="btn text-dark-green title font-weight-bolder collapsed"
                                                   data-toggle="collapse">
                                                    {{claim.description | capitalize}}
                                                </a>
                                            </div>
                                        </div>

                                        <div :aria-labelledby="'finance_heading'+index+index2"
                                             :class="{'show': index2+1 === service.items.length}"
                                             :data-parent="'#finance_accordionid'+index"
                                             :id="'finance_collapse'+index+index2"
                                             class="collapse">
                                            <div class="card-body">
                                                <form class="form-horizontal">
                                                    <div class="form-body">
                                                        <div class="card-body">
                                                            <h4 class="card-title m-b-30">
                                                                {{claim.description
                                                                | capitalize}}</h4>
                                                            <div :key="index"
                                                                 class="row"
                                                                 v-for="index in Math.ceil(claim.items.length/2)">
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row"
                                                                         v-if="claim.items[(index-1)*2]">
                                                                        <label class="col-sm-5 control-label"
                                                                               v-if="claim.items[(index-1)*2].name.indexOf('location') === -1">{{claim.items[(index-1)*2].name}}</label>
                                                                        <label class="col-sm-5 control-label"
                                                                               v-else>Location</label>
                                                                        <div class="col-sm-7">
                                                                            <p class="form-control-static"
                                                                               v-if="claim.items[(index-1)*2].name.indexOf('location') === -1">
                                                                                {{claim.items[(index-1)*2].fact.value}}</p>
                                                                            <a :href="'https://www.google.com/maps/search/'+claim.items[(index-1)*2].fact.value.replace(';', ',')"
                                                                               target="_blank"
                                                                               v-else
                                                                            >View
                                                                                on
                                                                                Map</a>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row"
                                                                         v-if="claim.items[(index-1)*2+1]">
                                                                        <label class="col-sm-5 control-label">{{claim.items[(index-1)*2+1].name}}</label>
                                                                        <div class="col-sm-7">
                                                                            <p class="form-control-static">
                                                                                {{claim.items[(index-1)*2+1].fact.value}}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row">
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row">
                                                                        <label class="col-sm-5 control-label">Status</label>
                                                                        <div class="col-sm-7">
                                                                                                                <span class="label label-warning"
                                                                                                                      v-if="claim.status==='Pending'">Not attested</span>
                                                                            <span class="label label-dark-green"
                                                                                  v-else-if="claim.status=== 'Attested'">Attested</span>
                                                                            <span class="label label-danger"
                                                                                  v-else-if="claim.status=== 'Expired'">Expired</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row">
                                                                        <label class="col-sm-5 control-label">Created
                                                                            by</label>
                                                                        <div class="col-sm-7 form-control-static">
                                                                            <profile-by-public-key
                                                                                    :public_key="claim.created_by"
                                                                                    v-if="claim.created_by"></profile-by-public-key>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div class="row"
                                                                 v-if="claim.status ==='Attested'">
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row">
                                                                        <label class="col-sm-5 control-label">Expiry</label>
                                                                        <div class="col-sm-7">
                                                                            <p class="form-control-static">
                                                                                {{claim.expiry
                                                                                |
                                                                                timestamp}}</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-sm-12 col-lg-6">
                                                                    <div class="form-group row">
                                                                        <label class="col-sm-5 control-label">Attested
                                                                            by</label>
                                                                        <div class="col-sm-7">
                                                                            <profile-by-public-key
                                                                                    :public_key="claim.attested_by"></profile-by-public-key>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <h6 class="card-title mt-3 mb-3"
                                                                v-if="claim.attachments.length > 0">
                                                                Claim
                                                                Attachments</h6>
                                                            <claim-attachments :attachments="claim.attachments"
                                                                               :claim_id="claim.claim"
                                                                               :memberid="memberid"></claim-attachments>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
    <div class="card-body p-30" v-else>
        <h4 class="card-title text-muted text-center">No records found</h4>
    </div>
</template>

<script>
    import ProfileByPublicKey from "../../../../common/ProfileByPublicKey";
    import ClaimAttachments from "./ClaimAttachments";

    export default {
        name: "FinancialTab",
        components: {ClaimAttachments, ProfileByPublicKey},
        props: ['service_list', 'memberid'],
        data() {
            return {
                activeTab: 1,
            }
        },
        methods: {
            tab(tabname) {
                this.activeTab = tabname;
            },
        }
    }
</script>

<style scoped>
    .service-active {
        color: #eef5f9 !important;
        background-color: #3aa548 !important;
    }

    .card-border {
        background-clip: border-box;
        border: 1px solid rgba(0, 0, 0, 0.125);
        border-radius: 0.25rem;
    }

    .card-header-border {
        border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    }
</style>
